export const PAGES_TEXT = 'Pages'
export const PROTOTYPES_TEXT = 'Prototypes'
export const COMPONENTS_TEXT = 'Components'
